<div class="header-wrapper">
  <!-- Header Tabs -->
  <div class="header-wrapper-right-button">
    <div [matTooltip]="'APPS.refresh_app' | translate">
      <button
        mat-stroked-button
        color="primary"
        aria-label="refresh"
        (click)="refreshAppName()"
      >
        <mat-icon>refresh</mat-icon>
        <span>{{ 'APPS.refresh_app' | translate }}</span>
      </button>
    </div>
    <div [matTooltip]="'ROLES.add' | translate">
      <button
        mat-stroked-button
        color="primary"
        aria-label="add"
        (click)="goToRoles()"
      >
        <mat-icon>add</mat-icon>
        <span>{{ 'ROLES.add' | translate }}</span>
      </button>
    </div>
    <div
      [matTooltip]="
        this.selection.selected.length > 0
          ? ('Delete_Roles' | translate)
          : ('Delete_Roles_Disabled' | translate)
      "
    >
      <button
        mat-stroked-button
        color="primary"
        aria-label="delete"
        (click)="goToDeleteRoles()"
        [disabled]="!(this.selection.selected.length > 0)"
      >
        <mat-icon>delete_outline</mat-icon>
        <span>{{ 'ROLES.delete' | translate }}</span>
      </button>
    </div>
  </div>
</div>
<!-- Apps Roles -->

<table mat-table [dataSource]="rolesDataSource">
  <ng-container matColumnDef="roleId">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell class="border" *matCellDef="let item; let i = index">
      <mat-checkbox
        color="primary"
        (click)="$event.stopPropagation()"
        (change)="$event ? changeCheckbox(item) : null"
        [checked]="selection.isSelected(item)"
      >
      </mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'Roles_Name' | translate }}
    </th>
    <td mat-cell *matCellDef="let item">{{ item.role }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
  ></tr>
</table>
<mat-paginator
  [showFirstLastButtons]="true"
  [pageSizeOptions]="[10, 25, 50, 100]"
></mat-paginator>
